import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen.js';
import { viewTransitionOption } from './view-transition.js';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultViewTransition: viewTransitionOption(),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
